import moment from 'moment'
import {
  CHARTER_FLIGHT_DETAILS,
  KIDS_FLY_FREE_CAMPAIGN_TAG,
  MALDIVES_CHARTER_BUNDLE_CAMPAIGN_TAG,
  MALDIVES_GROUP_VILLA_CHARTER_CAMPAIGN_TAG,
} from 'constants/charterFlight'
import type { FlightsClassTypes } from 'constants/flight'
import { getFlightSearchKey } from 'lib/flights/flightUtils'
import { CHARTER } from 'constants/provider'

export function isJourneyChildFree(journey?: App.JourneyV2): boolean {
  if (!journey) return false
  const childPrice = journey.price?.child
  if (!childPrice) return false
  if (childPrice.baseFare === undefined || childPrice.totalFare === undefined) return false
  return childPrice.baseFare === 0 && childPrice.totalFare === 0
}

export function deriveKidsFlyFreeDates(departingFares?: Array<App.JourneyV2>): Set<string> {
  const dates = new Set<string>()
  if (!departingFares) return dates
  for (const journey of departingFares) {
    if (isJourneyChildFree(journey)) {
      const departDate = journey.flightGroup?.flights?.[0]?.departingDate
      if (departDate) {
        dates.add(moment(departDate).format('YYYY-MM-DD'))
      }
    }
  }
  return dates
}

export function buildCharterFlightSearchKey(
  charterBundleRoute: App.CharterBundleRoute,
  occupancies: Array<App.Occupants>,
  fareClass: FlightsClassTypes,
  currency: string,
): string {
  const routeInfo = CHARTER_FLIGHT_DETAILS[charterBundleRoute]
  return getFlightSearchKey({
    itinerary: [
      {
        departureAirport: routeInfo.originAirport.airportCode ?? '',
        arrivalAirport: routeInfo.destinationAirport.airportCode ?? '',
        departureDate: routeInfo.dateRange.min,
      },
      {
        departureAirport: routeInfo.destinationAirport.airportCode ?? '',
        arrivalAirport: routeInfo.originAirport.airportCode ?? '',
        departureDate: routeInfo.dateRange.max,
      },
    ],
    occupancies,
    fareClass,
    source: CHARTER,
    currency,
  })
}

export function shouldShowKidsFlyFreeLabel(
  offer: { campaignTags?: Array<string> },
  checkInDate?: string,
  kidsFlyFreeDates?: Set<string>,
): boolean {
  if (!offer.campaignTags?.includes(MALDIVES_CHARTER_BUNDLE_CAMPAIGN_TAG)) return false
  if (!offer.campaignTags?.includes(KIDS_FLY_FREE_CAMPAIGN_TAG)) return false
  if (!checkInDate || !kidsFlyFreeDates) return true
  const departDate = moment(checkInDate).subtract(1, 'day').format('YYYY-MM-DD')
  return kidsFlyFreeDates.has(departDate)
}

export function shouldShowPerfectForGroupsLabel(
  offer: { campaignTags?: Array<string> },
): boolean {
  return offer.campaignTags?.includes(MALDIVES_GROUP_VILLA_CHARTER_CAMPAIGN_TAG) ?? false
}
